import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { generate } from "library/guid/index.mjs"

export function AddRuleButton({ onAdd }) {
    return (
        <Button
            variant="outlined"
            startIcon={<Iconify icon="mdi:plus" />}
            onClick={handleAdd}
            sx={{ alignSelf: "flex-start" }}
        >
            Add Rule
        </Button>
    )

    function handleAdd() {
        onAdd({
            id: generate(),
            type: "rule",
            name: "",
            conditions: [{ _id: generate(), field: "", operator: "", value: null }],
            action: { type: "include" },
        })
    }
}
